import { render, staticRenderFns } from "./PerSearch.vue?vue&type=template&id=37d9e7ee&scoped=true"
import script from "./PerSearch.vue?vue&type=script&lang=js"
export * from "./PerSearch.vue?vue&type=script&lang=js"
import style0 from "./PerSearch.vue?vue&type=style&index=0&id=37d9e7ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d9e7ee",
  null
  
)

export default component.exports